export var PreventionTrackingType;
(function (PreventionTrackingType) {
    PreventionTrackingType["COMPLETE"] = "COMPLETE";
    PreventionTrackingType["IN_QUIZ"] = "IN_QUIZ";
})(PreventionTrackingType || (PreventionTrackingType = {}));
//# sourceMappingURL=prevention-tracking-type.js.map